import { render } from "./auth_form.vue?vue&type=template&id=32d37134"
import script from "./auth_form.vue?vue&type=script&lang=js"
export * from "./auth_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__